import { useCallback, useEffect, useState } from "react";

// The five portal colours. Each unit keeps its own; an officer may still overrule it for themselves.
export const ACCENTS = {
  blue: { label: "Blue", swatch: "#2A7BE0" },
  green: { label: "Green", swatch: "#12864A" },
  red: { label: "Red", swatch: "#C2262F" },
  orange: { label: "Orange", swatch: "#EA580C" },
  cyan: { label: "Cyan", swatch: "#0E7490" },
};

export const DEFAULT_ACCENT = "blue";
const KEY = "sail_dx_accent";
const MINE = "sail_dx_accent_mine";

const read = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const readAccent = () => {
  const saved = read(KEY);
  return saved && ACCENTS[saved] ? saved : DEFAULT_ACCENT;
};

export const hasOwnChoice = () => read(MINE) === "1";

export const useAccent = () => {
  const [accent, set] = useState(readAccent);

  useEffect(() => {
    document.documentElement.setAttribute("data-accent", accent);
    try {
      localStorage.setItem(KEY, accent);
    } catch (e) {
      /* a browser with storage turned off still gets the colour for this visit */
    }
  }, [accent]);

  // The officer picks a colour for themselves — it outranks their unit's colour from then on.
  const choose = useCallback((next) => {
    if (!ACCENTS[next]) return;
    try {
      localStorage.setItem(MINE, "1");
    } catch (e) {
      /* nothing to remember, the colour still applies now */
    }
    set(next);
  }, []);

  // The unit's own colour — applied unless this officer has chosen one for themselves.
  const followUnit = useCallback((next) => {
    if (ACCENTS[next] && !hasOwnChoice()) set(next);
  }, []);

  // Back to whatever colour the unit carries.
  const clearOwnChoice = useCallback((unitAccent) => {
    try {
      localStorage.removeItem(MINE);
    } catch (e) {
      /* nothing was remembered */
    }
    if (ACCENTS[unitAccent]) set(unitAccent);
  }, []);

  return { accent, choose, followUnit, clearOwnChoice, ownChoice: hasOwnChoice() };
};
